import React, {useMemo} from 'react';
import cn from 'classnames';

import SearchModel from 'coreClasses/search/SearchModel';
import {useSearchMgrInstance} from 'coreHooks';
import {useCategory, useParentCategoryTree} from 'coreHooks/categories';

import styles from 'brandComponents/Breadcrumbs/Breadcrumbs.module.scss';
import {Breadcrumb} from 'brandComponents/Breadcrumbs/Subcomponents';

import {IProductBreadcrumbs} from './IProductBreadcrumbs';

const ProductBreadcrumbs: React.FC<IProductBreadcrumbs> = (
	{
		selectedProduct,
		prefixItems = [],
		cgid,
		showProductName = true,
		lastCategoryLabelVariant
	}: IProductBreadcrumbs) => {
	const homeItem = useMemo(() => ({
		url: '/',
		label: 'Home'
	}), []);

	prefixItems.push(homeItem);

	const searchMgr = useSearchMgrInstance();
	const searchModel: SearchModel = searchMgr.getStoredSearchModel();
	const category = useCategory(selectedProduct?.getPrimaryCategoryId() || searchModel?.getSelectedRefinements()?.cgid || cgid);
	const parentCategoryTree = useParentCategoryTree(category);

	return (
		<div className={cn('breadcrumbs-container', styles['breadcrumbs__container'])}>
			<ul className={cn(styles['breadcrumbs'], styles['breadcrumbs__list'])}>
				{!!prefixItems.length && prefixItems.map(item => (
					<li key={item.label} className={styles['breadcrumbs__item']}>
						<Breadcrumb {...item} classNames={styles['breadcrumbs__item-link']} />
					</li>
				))}
				{parentCategoryTree ? (
					parentCategoryTree.map((category, index: Number) => {
						const url = selectedProduct?.getProductId() || parentCategoryTree.length !== +index + 1
							? category?.getUrl()
							: null;

						return (
							<li key={category?.getId()} className={styles['breadcrumbs__item']}>
								<Breadcrumb
									classNames={styles['breadcrumbs__item-link']}
									url={url}
									category={category}
									labelVariant={
										index === (parentCategoryTree.length - 1) && lastCategoryLabelVariant
											? lastCategoryLabelVariant
											: 'span'
									}
								/>
							</li>
						);
					})
				) : (
					<li className={styles['breadcrumbs__item']} />
				)}
				{showProductName && !!selectedProduct && !!selectedProduct?.getName() && (
					<li className={styles['breadcrumbs__item']}>
						<Breadcrumb label={selectedProduct?.getName()} />
					</li>
				)}
			</ul>
		</div>
	);
};

export default ProductBreadcrumbs;
